import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as storesActions from './store-details-actions';
import {catchError, exhaustMap, map, takeUntil, withLatestFrom} from 'rxjs/operators';
import {of, Subject, Subscription} from 'rxjs';
import {StoreService} from '@app/marketplace/stores/_services/store.service';
import * as routerSelectors from '@app/marketplace/route/router-state.selectors';
import * as locationSelectors from '@app/marketplace/locations/state/locations-selectors';
import {Store} from '@ngrx/store';

@Injectable()
export class StoreDetailsEffects {

  constructor(private actions$: Actions, private store: Store<any>, private service: StoreService) {
}

loadStoreDetails$ = createEffect(() =>
  this.actions$.pipe(
    ofType(storesActions.LOADING_STORE_DETAILS),
    withLatestFrom(
      this.store.select(routerSelectors.getMergedRoute),
      this.store.select(locationSelectors.selectLocation),
      (action: any, router: any, location: any) => {
        return {
          action,
          params: router.params,
          location: {type: location.locationType, codes: location.locations},
        };
      }
    ),
    exhaustMap((data: any, index) => {
      const payload = {
        code: data.params['id'],
        locations: data.location?.codes || [],
        locationType: data.location.type || 0,
        locationResolver: false,
        pageSize: 12
      };
      return this.service.GetStoreDetail(payload).pipe(
        takeUntil(this.actions$.pipe(ofType(storesActions.CANCEL_STORE_DETAILS_REQUEST))),
        map((dataAction: any) => {
          return ({type: storesActions.STORE_DETAILS, data: dataAction.data});
        }),
        catchError((error) => of({type: storesActions.ERROR_STORE_DETAILS}))
      );
    })
  )
);
}
